export function dispatchCustomEvent(event: Event): boolean {
  return window.dispatchEvent(event);
}
